import React from 'react';
import { Video } from 'lucide-react';

interface LiveVideoPreviewerProps {
    videoUrl?: string;
}

const LiveVideoPreviewer: React.FC<LiveVideoPreviewerProps> = ({ videoUrl }) => {
    if (!videoUrl) {
        return (
            <div className="fallback-content w-full h-full flex flex-col items-center justify-center gap-1 text-gray-500">
                <Video className="h-6 w-6" />
                <span className="text-xs">Live Video Placeholder</span>
                <span className="text-xs text-gray-400">Enter a YouTube URL</span>
            </div>
        );
    }
    const videoId = videoUrl.split('/').pop()?.split('?')[0];
    const embedUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1&loop=1&playlist=${videoId}`;

    return (
        <div className="w-full h-full relative" style={{ overflow: 'hidden', backgroundColor: '#000' }}>
            <iframe
                src={embedUrl}
                className="w-full h-full"
                style={{ 
                    width: '100%', 
                    height: '100%',
                    border: 'none'
                }}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                title="Live Video Player"
            />
        </div>
    );
};

export default LiveVideoPreviewer;
